var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCategoryDonuts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_465_8926)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_465_8926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.4238 12.5206C34.0041 12.5206 0.423828 40.6953 0.423828 75.4539C0.423828 110.212 34.0041 138.387 75.4238 138.387C116.844 138.387 150.424 110.212 150.424 75.4539C150.424 40.6953 116.844 12.5206 75.4238 12.5206ZM75.6435 39.613C75.5571 39.6127 75.4715 39.6098 75.3847 39.6101C75.3977 39.6101 75.4106 39.6095 75.4235 39.6095C75.4977 39.6095 75.57 39.6127 75.6435 39.613ZM75.4238 71.2989C65.3415 71.2989 56.6909 67.3209 52.9812 61.6483C56.6791 55.9809 65.2894 51.9809 75.3453 51.9312C85.4753 51.8809 94.1785 55.8539 97.8874 61.5512C94.1944 67.2483 85.5338 71.2989 75.4238 71.2989Z",
    fill: "url(#paint0_linear_465_8926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4238 12.5206C34.0041 12.5206 0.423828 40.6953 0.423828 75.4539C0.423828 110.212 34.0041 138.387 75.4238 138.387C116.844 138.387 150.424 110.212 150.424 75.4539C150.424 40.6953 116.844 12.5206 75.4238 12.5206ZM75.6435 39.613C75.5571 39.6127 75.4715 39.6098 75.3847 39.6101C75.3977 39.6101 75.4106 39.6095 75.4235 39.6095C75.4977 39.6095 75.57 39.6127 75.6435 39.613ZM75.4238 71.2989C65.3415 71.2989 56.6909 67.3209 52.9812 61.6483C56.6791 55.9809 65.2894 51.9809 75.3453 51.9312C85.4753 51.8809 94.1785 55.8539 97.8874 61.5512C94.1944 67.2483 85.5338 71.2989 75.4238 71.2989Z",
    fill: "url(#paint1_linear_465_8926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.424 75.4542H109.557C82.4828 75.4542 60.5345 97.4027 60.5345 124.477C60.5345 126.58 61.4707 128.461 62.9443 129.738L71.509 138.302C72.8054 138.358 74.1107 138.387 75.4237 138.387C116.843 138.387 150.424 110.212 150.424 75.4542Z",
    fill: "url(#paint2_linear_465_8926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.424 75.4542H127.192C103.032 75.4542 83.446 95.04 83.446 119.2C83.446 121.352 84.4004 123.319 85.9154 124.642L97.0101 135.737C127.907 127.957 150.424 103.915 150.424 75.4542Z",
    fill: "url(#paint3_linear_465_8926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.424 75.4542C150.424 58.4762 142.409 43.0715 129.385 31.7515V96.3886C129.487 98.2709 130.339 99.9518 131.644 101.145L139.148 108.649C146.293 99.0121 150.424 87.6389 150.424 75.4542Z",
    fill: "url(#paint4_linear_465_8926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.424 60.3686C150.424 33.2086 116.844 11.193 75.4238 11.193C34.0041 11.193 0.423828 33.2083 0.423828 60.3686C0.423828 65.6727 1.70677 70.7798 4.07765 75.5653C6.42736 80.3077 7.56118 85.5601 7.56118 90.8527V101.139C7.56118 104.981 10.5956 108.234 14.4371 108.281C16.3924 108.305 18.1641 107.52 19.4424 106.242C20.7018 104.983 21.4815 103.241 21.4815 101.319C21.4815 98.4198 24.5909 96.5877 27.1288 97.9901C34.4353 102.027 42.9335 105.165 52.2288 107.146C57.0588 108.175 60.5347 112.404 60.5347 117.342V124.477C60.5347 128.323 63.6509 131.439 67.4932 131.439C69.4144 131.439 71.1565 130.659 72.4159 129.4C73.6753 128.141 74.455 126.399 74.455 124.477V117.185C74.455 114.703 76.4674 112.688 78.9521 112.688C80.1912 112.688 81.3153 113.191 82.1291 114.004C82.9429 114.822 83.4459 115.942 83.4459 117.185V119.199C83.4459 123.04 86.4806 126.294 90.3218 126.341C92.2768 126.364 94.0488 125.58 95.3271 124.302C96.5865 123.042 97.3662 121.304 97.3662 119.379V115.919C97.3662 111.094 100.553 106.833 105.195 105.515C113.8 103.072 121.569 99.6024 128.144 95.3415C128.671 94.9995 129.366 95.3798 129.366 96.0086C129.366 99.8506 132.483 102.967 136.328 102.967C138.249 102.967 139.988 102.187 141.247 100.928C142.507 99.6686 143.287 97.9298 143.287 96.0089V89.1277C143.287 84.6915 144.299 80.2971 146.361 76.3689C148.993 71.353 150.424 65.9706 150.424 60.3686ZM75.3453 39.6098C88.8097 39.543 99.7568 46.5824 99.8 55.3336C99.8435 64.0848 88.9668 71.2321 75.5024 71.2989C62.0379 71.3656 51.0909 64.3262 51.0477 55.5751C51.0041 46.8239 61.8809 39.6762 75.3453 39.6098Z",
    fill: "url(#paint5_radial_465_8926)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M32.8123 111.13C34.3841 111.13 35.6582 109.856 35.6582 108.284C35.6582 106.712 34.3841 105.438 32.8123 105.438C31.2406 105.438 29.9664 106.712 29.9664 108.284C29.9664 109.856 31.2406 111.13 32.8123 111.13Z",
    fill: "url(#paint6_linear_465_8926)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25.0168 115.147C26.2576 115.147 27.2636 114.141 27.2636 112.901C27.2636 111.66 26.2576 110.654 25.0168 110.654C23.7759 110.654 22.77 111.66 22.77 112.901C22.77 114.141 23.7759 115.147 25.0168 115.147Z",
    fill: "url(#paint7_linear_465_8926)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M33.2278 119.916C33.9758 119.916 34.5822 119.31 34.5822 118.562C34.5822 117.814 33.9758 117.207 33.2278 117.207C32.4797 117.207 31.8734 117.814 31.8734 118.562C31.8734 119.31 32.4797 119.916 33.2278 119.916Z",
    fill: "url(#paint8_linear_465_8926)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M45.7307 118.397C46.8922 118.397 47.8337 117.456 47.8337 116.294C47.8337 115.133 46.8922 114.191 45.7307 114.191C44.5693 114.191 43.6278 115.133 43.6278 116.294C43.6278 117.456 44.5693 118.397 45.7307 118.397Z",
    fill: "url(#paint9_linear_465_8926)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M39.3479 115.935C40.2649 115.935 41.0082 115.192 41.0082 114.275C41.0082 113.358 40.2649 112.615 39.3479 112.615C38.431 112.615 37.6876 113.358 37.6876 114.275C37.6876 115.192 38.431 115.935 39.3479 115.935Z",
    fill: "url(#paint10_linear_465_8926)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.2754 122.587C40.8281 122.587 41.2762 122.139 41.2762 121.586C41.2762 121.033 40.8281 120.585 40.2754 120.585C39.7226 120.585 39.2745 121.033 39.2745 121.586C39.2745 122.139 39.7226 122.587 40.2754 122.587Z",
    fill: "url(#paint11_linear_465_8926)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M132.313 109.08C133.475 109.08 134.416 108.139 134.416 106.977C134.416 105.816 133.475 104.874 132.313 104.874C131.152 104.874 130.21 105.816 130.21 106.977C130.21 108.139 131.152 109.08 132.313 109.08Z",
    fill: "url(#paint12_linear_465_8926)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M125.93 106.619C126.847 106.619 127.591 105.876 127.591 104.959C127.591 104.042 126.847 103.298 125.93 103.298C125.014 103.298 124.27 104.042 124.27 104.959C124.27 105.876 125.014 106.619 125.93 106.619Z",
    fill: "url(#paint13_linear_465_8926)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M126.858 113.27C127.411 113.27 127.859 112.822 127.859 112.269C127.859 111.717 127.411 111.269 126.858 111.269C126.305 111.269 125.857 111.717 125.857 112.269C125.857 112.822 126.305 113.27 126.858 113.27Z",
    fill: "url(#paint14_linear_465_8926)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M81.0534 18.5083C79.6414 15.7398 75.4078 15.5139 73.9393 15.4359C70.5126 15.2542 65.7708 15.6724 59.8437 16.6777C34.6902 20.9433 14.664 41.8768 13.8237 42.7659C12.8631 43.7824 12.9084 45.3851 13.9249 46.3456L22.1725 54.2915C18.6399 58.138 15.2802 62.7862 14.4011 67.2351C13.5952 71.3118 15.157 73.8342 16.609 75.2321L47.3584 105.981C48.9558 106.404 50.5793 106.794 52.229 107.146C57.059 108.175 60.5349 112.404 60.5349 117.342V119.158L71.5237 130.147C71.8408 129.921 72.1417 129.674 72.4161 129.4C73.6755 128.141 74.4552 126.399 74.4552 124.477V117.185C74.4552 114.703 76.4676 112.688 78.9523 112.688C80.1914 112.688 81.3155 113.191 82.1293 114.004C82.9431 114.822 83.4461 115.942 83.4461 117.185V119.199C83.4461 123.04 86.4808 126.294 90.322 126.341C92.2773 126.364 94.049 125.58 95.3273 124.302C96.5867 123.042 97.3664 121.304 97.3664 119.379V115.919C97.3664 111.094 100.553 106.833 105.195 105.515C113.8 103.072 121.569 99.6024 128.144 95.3415C128.671 94.9995 129.367 95.3798 129.367 96.0086C129.367 99.8506 132.483 102.967 136.328 102.967C138.25 102.967 139.988 102.187 141.248 100.928C142.507 99.6686 143.287 97.9298 143.287 96.0089V89.1277C143.287 86.6195 143.611 84.1245 144.265 81.7198L81.0534 18.5083ZM75.5026 71.2986C62.0381 71.3653 51.0911 64.3259 51.0478 55.5748C51.0046 46.8236 61.8811 39.6762 75.3455 39.6095C88.8099 39.5427 99.757 46.5821 99.8002 55.3333C99.8437 64.0845 88.967 71.2321 75.5026 71.2986Z",
    fill: "url(#paint15_linear_465_8926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6864 77.4603C20.1879 77.4606 18.1473 76.7133 16.609 75.2321C15.157 73.8342 13.5952 71.3121 14.4011 67.235C15.8302 60.0047 23.8093 52.2445 28.4384 48.2624C36.1399 41.6371 45.6287 35.8342 54.4726 32.3415C69.0564 26.5815 74.5455 22.5403 76.0261 20.813C74.597 20.4403 70.6211 19.9871 60.6905 21.6709C37.1899 25.6559 17.6987 46.0389 17.5049 46.2445C16.5443 47.2609 14.942 47.3062 13.9252 46.3456C12.9087 45.385 12.8634 43.7824 13.824 42.7659C14.6643 41.8768 34.6902 20.9433 59.844 16.6777C65.7711 15.6727 70.5129 15.2542 73.9396 15.4359C75.532 15.52 80.3773 15.7762 81.3496 19.2612C82.3467 22.8353 78.1714 26.0092 74.9443 28.0853C70.6887 30.8233 64.2531 33.9236 56.3331 37.0518C47.9946 40.345 39.0314 45.8306 31.7417 52.1018C24.8108 58.0639 20.1858 64.0886 19.3699 68.2171C18.9767 70.2071 19.6108 71.0918 20.1223 71.5839C21.6052 73.0109 25.1334 72.5653 30.3261 70.295C36.5899 67.5565 44.5317 62.438 50.7505 58.2847C51.9131 57.5077 53.4858 57.8212 54.2626 58.9842C55.0393 60.1471 54.7261 61.7197 53.5631 62.4962C47.1705 66.7656 38.9826 72.0377 32.3543 74.9353C28.9955 76.4039 26.2002 77.2142 23.809 77.4124C23.4252 77.4445 23.0508 77.4603 22.6864 77.4603Z",
    fill: "url(#paint16_linear_465_8926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.424 60.3689C150.424 65.9701 148.992 71.3518 146.359 76.3689C144.3 80.2953 143.287 84.6912 143.287 89.1277V96.0086C143.287 96.7209 143.179 97.413 142.976 98.0612L99.7869 54.8724C99.4257 47.465 91.2484 41.3774 80.4545 39.9359C80.4748 39.1053 80.8969 38.2986 81.6566 37.8324C91.0695 32.0253 99.9895 27.1027 106.026 25.2727C113.903 22.8824 119.91 23.5845 123.877 27.3659L149.617 53.1503C150.147 55.5071 150.424 57.9145 150.424 60.3689Z",
    fill: "url(#paint17_linear_465_8926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.931 55.1456C100.012 55.1456 99.1259 54.6442 98.6768 53.7709C98.0371 52.5274 98.5271 51.0006 99.7709 50.3609C105.575 47.3762 120.993 39.4477 121.775 34.023C121.866 33.3959 121.82 32.4036 120.381 31.0321C115.479 26.3592 102.522 30.9121 84.3145 42.1418C83.1242 42.8756 81.5645 42.5059 80.8301 41.3156C80.0962 40.1253 80.4657 38.565 81.6562 37.8309C91.0692 32.0256 99.9877 27.1027 106.024 25.2712C113.904 22.8809 119.91 23.5856 123.875 27.3668C126.765 30.1215 127.054 32.9003 126.788 34.7462C125.829 41.3947 116.219 47.5971 102.087 54.865C101.716 55.0553 101.321 55.1456 100.931 55.1456Z",
    fill: "url(#paint18_linear_465_8926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.183 64.3136L140.985 55.1159C140.554 54.61 140.023 54.1227 139.392 53.6547C129.922 46.635 111.18 59.2768 91.3399 72.6609C86.4873 75.9344 81.8011 79.0947 77.4046 81.855C77.3822 81.8412 77.3602 81.8271 77.3375 81.8141C77.3172 81.7791 66.2058 70.65 66.1837 70.6159C66.0217 70.3647 65.8211 70.1544 65.597 69.9824C65.0293 69.8212 64.4705 69.6494 63.9267 69.4615C63.4981 69.483 63.0693 69.6115 62.6831 69.8609C55.6005 74.4306 46.4802 81.4565 49.0343 89.6736C49.6717 91.7239 50.6905 93.0853 51.769 93.9915L74.4814 116.704C74.7214 114.448 76.6299 112.687 78.952 112.687C80.1911 112.687 81.3152 113.19 82.129 114.004C82.9428 114.821 83.4458 115.942 83.4458 117.184V119.199C83.4458 123.04 86.4805 126.294 90.3217 126.34C92.277 126.364 94.0487 125.58 95.327 124.301C96.5864 123.042 97.3661 121.303 97.3661 119.379V115.919C97.3661 111.094 100.553 106.832 105.195 105.515C113.8 103.072 121.569 99.6021 128.143 95.3412C128.671 94.9991 129.366 95.3794 129.366 96.0083C129.366 99.8503 132.483 102.967 136.328 102.967C138.249 102.967 139.988 102.187 141.247 100.928C142.507 99.6683 143.287 97.9294 143.287 96.0086V89.1274C143.287 84.6912 144.299 80.2968 146.36 76.3686C148.368 72.5421 149.675 68.5015 150.183 64.3136Z",
    fill: "url(#paint19_linear_465_8926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4076 95.8753C56.2447 95.8756 55.1676 95.7118 54.1814 95.3653C52.4511 94.7574 50.1541 93.2762 49.0341 89.6736C46.4797 81.4562 55.6003 74.4306 62.6829 69.8609C63.8576 69.1027 65.4253 69.4406 66.1835 70.6159C66.9417 71.7912 66.6038 73.3583 65.4285 74.1165C56.6256 79.7962 52.7367 84.5244 53.8703 88.1703C54.4014 89.8795 55.2129 90.3597 55.8608 90.5874C57.5288 91.1733 61.2453 90.9439 69.4761 86.52C75.9632 83.0339 83.432 77.9953 91.34 72.6609C111.181 59.2768 129.922 46.635 139.392 53.6547C141.44 55.1724 142.44 56.8974 142.364 58.7818C142.212 62.5797 138.049 65.1765 131.154 69.4783C123.38 74.3274 112.734 80.9689 104.128 91.8886C103.261 92.9871 101.67 93.1756 100.571 92.3097C99.4732 91.4441 99.2847 89.8518 100.15 88.7536C109.304 77.1397 120.383 70.228 128.473 65.1815C132.039 62.9568 136.904 59.9224 137.291 58.6147C137.232 58.5074 137.023 58.203 136.376 57.7236C129.783 52.8368 110.038 66.1568 94.172 76.8594C79.1773 86.9744 65.9823 95.8744 57.4076 95.8753Z",
    fill: "url(#paint20_linear_465_8926)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_465_8926",
    x1: 44.4524,
    y1: 64.178,
    x2: 114.003,
    y2: 89.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2061,
    stopColor: "#FBA682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#FDA861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_465_8926",
    x1: 44.4524,
    y1: 64.178,
    x2: 114.003,
    y2: 89.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2061,
    stopColor: "#FBA682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#FDA861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_465_8926",
    x1: 115.054,
    y1: 105.445,
    x2: -15.044,
    y2: 114.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_465_8926",
    x1: 119.067,
    y1: 105.055,
    x2: 41.638,
    y2: 110.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_465_8926",
    x1: 164.088,
    y1: 89.7701,
    x2: 137.078,
    y2: 72.0448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_465_8926",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.9318 41.7112) scale(100.275 69.19)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#A47950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4581,
    stopColor: "#A26F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6356,
    stopColor: "#9F5F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8011,
    stopColor: "#9A4838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9568,
    stopColor: "#942B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_465_8926",
    x1: 32.9123,
    y1: 112.306,
    x2: 30.821,
    y2: 98.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_465_8926",
    x1: 24.9731,
    y1: 116.017,
    x2: 23.3226,
    y2: 105.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_465_8926",
    x1: 32.9705,
    y1: 120.34,
    x2: 31.9753,
    y2: 114.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_465_8926",
    x1: 43.5902,
    y1: 118.433,
    x2: 49.8862,
    y2: 110.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_465_8926",
    x1: 37.635,
    y1: 115.89,
    x2: 42.6053,
    y2: 109.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_465_8926",
    x1: 39.1952,
    y1: 122.424,
    x2: 42.1918,
    y2: 118.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_465_8926",
    x1: 130.163,
    y1: 109.141,
    x2: 136.459,
    y2: 101.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_465_8926",
    x1: 124.208,
    y1: 106.599,
    x2: 129.178,
    y2: 100.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_465_8926",
    x1: 125.768,
    y1: 113.132,
    x2: 128.765,
    y2: 109.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_465_8926",
    x1: 73.5896,
    y1: 69.9356,
    x2: -10.3104,
    y2: -35.4032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_465_8926",
    x1: 37.5352,
    y1: 28.4709,
    x2: 65.8958,
    y2: 75.2883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_465_8926",
    x1: 133.913,
    y1: 65.3983,
    x2: 44.9695,
    y2: -23.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_465_8926",
    x1: 102.589,
    y1: 34.5753,
    x2: 123.324,
    y2: 59.8177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_465_8926",
    x1: 113.684,
    y1: 106.434,
    x2: 64.0532,
    y2: 3.12033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_465_8926",
    x1: 89.9829,
    y1: 63.5353,
    x2: 110.916,
    y2: 100.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_465_8926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0.621582)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_465_8926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0.423828 -0.209961)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategoryDonuts);
export default __webpack_public_path__ + "static/media/icon-category-donuts.fc0b826b.svg";
export { ForwardRef as ReactComponent };